module.exports = __webpack_public_path__ + "img/ooredoo_logo.a04ab533.png";